/* eslint-disable @next/next/no-img-element */
import Image from 'next/image';
import { numberWithCommas, displayWithK } from 'utilities/helper';
import { Profiler, useEffect, useState } from 'react';
import { isEmpty, head } from 'lodash';
import { getCookie, removeCookie } from "framework/libs/cookie";
import { CART, TOKEN_SHOP, TOKEN_CONGDONG, TOKEN_CHAT } from "framework/store/constants";
import { useCart } from "framework/store";
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { isArray } from "lodash";
import { apiAddProductToCart, createCart, fetchCartProduct, applyDiscountItem } from "framework/api/cart";
import isEqual from 'lodash/isEqual';
import { Loader } from 'components/loader';
import { Button, Modal } from "react-bootstrap";
import http from "utilities/http";
import dayjs from "dayjs";
import CouponProduct from 'components/coupon';
import { formatSku, getXXXPrice } from 'utilities/helper';
import StarList from 'components/shop/review/starList';

export function Coupon({ value }) {
    return <div className="coupon-display p-1 pl-2 pr-2 mr-1">
        <div className="info-code coupon-display-inner" style={{ color: '#34beef', fontSize: 13, fontWeight: 500 }}>
            {value}
        </div>
    </div>;
}

export default function Index({ productDetail, vendor }) {
    const groupId = vendor.group_id;
    const [loading, setLoading] = useState(false);
    const [childProduct, setChildProduct] = useState(productDetail);
    const [ship, setShip] = useState('');
    const [futurePrice, setFuturePrice] = useState(null);

    const [childrenProduct, setChildrenProduct] = useState([]);
    useEffect(() => {
        const fetch = async () => {
            const notVneProduct = await http(`/rest/V1/products/${`${formatSku(productDetail.sku)}`}`, {}, { token: 'default' });
            let ship = 'all';

            if (notVneProduct?.extension_attributes?.ship_provinces) {
                ship = notVneProduct.extension_attributes.ship_provinces;
            }

            setShip(ship);

            if (notVneProduct?.extension_attributes?.future_price) {
                let futurePrice = '';

                const flashSalePrice = notVneProduct?.extension_attributes?.future_price?.flashsale_price;
                const dealHotPrice = notVneProduct?.extension_attributes?.future_price?.dealhot_price;

                if (flashSalePrice && dealHotPrice) {
                    if (dayjs(flashSalePrice[1]).diff(dayjs(dealHotPrice[1]), 'minute') >= 0) {
                        futurePrice = dealHotPrice;
                    } else {
                        futurePrice = flashSalePrice;
                    }
                }

                if (flashSalePrice && !dealHotPrice) {
                    futurePrice = flashSalePrice;
                }

                if (!flashSalePrice && dealHotPrice) {
                    futurePrice = dealHotPrice;
                }

                setFuturePrice(futurePrice);
            }
        };

        fetch();
    }, []);

    useEffect(() => {
        const fetch = async () => {
            const res = await http(`/rest/V1/configurable-products/${`${formatSku(productDetail.sku)}`}/children`, {});
            if (isArray(res)) {
                const options = productDetail.extension_attributes.hpn_product_option;

                res.forEach(child => {
                    child.options = {};
                    options.forEach(x => {
                        if (child.custom_attributes.some(y => y.value == x.value)) {
                            child.options[x.attribute_label] = x.label;
                        }
                    });
                });

                setChildrenProduct(res);
            };
        };

        fetch();
    }, []);
    //default option
    const router = useRouter();
    let defaultOption = [];
    if (productDetail.type_id === 'configurable') {
        // defaultOption = productDetail.extension_attributes.configurable_product_options.map(item => {
        //     return { attribute_id: +item?.attribute_id || 0, attribute_value: head(item.values)?.value_index || '' };
        // });
        defaultOption = productDetail?.extension_attributes?.configurable_product_stock[0].super_product_attributes;
    }
    const [stateCart, actions] = useCart();
    const [state, _setState] = useState({
        quantity: 1,
        isCouponModalDisplay: false,
        productOptions: defaultOption,
        showModalCoupon: false,
        showModalFreeShip: false,
        showModalShipping: false,
        couponsVendor: [],
        couponsFreeShip: [],
        couponsHappynest: [],
        couponDisplay: [],
    });
    const setState = (_state) => {
        _setState((state) => ({
            ...state,
            ..._state || {}
        }));
    };

    const handleLogout = () => {
        toast.error("Đã có lỗi xảy ra, hãy đăng nhập lại để tiếp tục.");
        removeCookie(TOKEN_CHAT);
        removeCookie(TOKEN_CONGDONG);
        removeCookie(TOKEN_SHOP);
        removeCookie(CART);
        actions.setProfileCommunity(null);
        actions.cart(null);
    };

    const addProductToCart = async () => {
        if (isEmpty(getCookie(TOKEN_SHOP))) {
            toast.info('Bạn cần đăng nhập để thao tác');
            return false;
        }
        try {
            if ((productDetail?.type_id == 'simple' && productDetail?.extension_attributes?.qty == 0) || (productDetail?.type_id == 'configurable' && childProduct.qty == 0)) {
                toast.error('Sản phẩm đã hết hàng');
                return false;
            }
            setLoading(true);
            let body = {};
            if (isEmpty(stateCart.cart?.customer)) {
                const createCartAPI = await createCart();
                if (createCartAPI?.message && createCartAPI?.message.indexOf("The consumer isn't authorized") > -1) {
                    setLoading(false);
                    handleLogout();
                    return false;
                }
                const cart = await fetchCartProduct();
                body = {
                    cartItem: {
                        quote_id: !isEmpty(getCookie(TOKEN_SHOP)) ? cart.id : getCookie(CART),
                        sku: productDetail.type_id === 'simple' ? productDetail.sku : childProduct.sku,
                        qty: state.quantity,
                    }
                };
                actions.cart(cart);
            } else {
                body = {
                    cartItem: {
                        quote_id: !isEmpty(getCookie(TOKEN_SHOP)) ? stateCart.cart.id : getCookie(CART),
                        sku: productDetail.type_id === 'simple' ? productDetail.sku : childProduct.sku,
                        qty: state.quantity,
                    }
                };
            }
            const apiAdd = await apiAddProductToCart(body);
            if (apiAdd?.message) {
                setLoading(false);
                if (apiAdd.message.indexOf("The consumer isn't authorized") > -1) {
                    handleLogout();
                } else {
                    toast.error(apiAdd.message);
                }
                return false;
            }

            const response = await fetchCartProduct();
            if (response?.message && response?.message.indexOf("The consumer isn't authorized") > -1) {
                setLoading(false);
                handleLogout();
                return false;
            }
            actions.cart(response);
            setLoading(false);
            toast.info('Thêm sản phẩm thành công');
            return true;
        } catch (e) {
            setLoading(false);
            toast.error("Đã có lỗi xảy ra.");
            console.log(e);
            return false;
        }
    };

    const buyNow = async () => {
        if (isEmpty(getCookie(TOKEN_SHOP))) {
            toast.info('Bạn cần đăng nhập để thao tác');
            return;
        }
        const result = await addProductToCart();
        if (result) router.push('/shop/cart');
    };

    const genPrice = () => {
        let giaGoc = 0;
        let giaGiam = 0;
        let loaiGiam = ''; //by_fixed by_percent
        let giaCuoiCung = 0;
        let special_price = dayjs(productDetail.custom_attributes?.special_to_date).diff(dayjs(), 'minute') >= 0 && dayjs(productDetail.custom_attributes?.special_from_date).diff(dayjs(), 'minute') <= 0
            ? productDetail.custom_attributes?.special_price
            : 0;

        if (productDetail?.type_id != 'configurable') {
            giaGoc = productDetail?.price;
            if (productDetail.price < 2) {
                return (<strong className="price_buy">Liên hệ đặt hàng</strong>);
            }
            if (productDetail.custom_attributes?.special_price) {
                special_price = dayjs(productDetail.custom_attributes?.special_to_date).diff(dayjs(), 'minute') >= 0 && dayjs(productDetail.custom_attributes?.special_from_date).diff(dayjs(), 'minute') <= 0
                    ? productDetail.custom_attributes?.special_price
                    : 0;
            }
            if (!isEmpty(productDetail.extension_attributes?.deal_hot_data)) {
                const saleData = productDetail.extension_attributes?.deal_hot_data[0];
                // productDetail.price_discount = saleData.price_deal_hot;
                giaCuoiCung = saleData.price_deal_hot;

                if (saleData.deal_hot_discount_type == 'by_percent' && saleData.deal_hot_discount_value > 0) {
                    giaGiam = saleData.deal_hot_discount_value;
                    loaiGiam = 'by_percent';
                }
                if (saleData.deal_hot_discount_type == 'by_fixed' && saleData.deal_hot_discount_value > 0) {
                    giaGiam = saleData.deal_hot_discount_value;
                    loaiGiam = 'by_fixed';
                }
            };

            if (!isEmpty(productDetail.extension_attributes?.flash_sales_data)) {
                const saleData = productDetail.extension_attributes?.flash_sales_data[0];
                productDetail.price_discount = saleData.price_flash_sales;
                giaCuoiCung = saleData.price_flash_sales;

                if (saleData.flash_sales_discount_type == 'by_percent' && saleData.flash_sales_discount_value > 0) {
                    giaGiam = saleData.flash_sales_discount_value;
                    loaiGiam = 'by_percent';
                }
                if (saleData.flash_sales_discount_type == 'by_fixed' && saleData.flash_sales_discount_value > 0) {
                    giaGiam = saleData.flash_sales_discount_value;
                    loaiGiam = 'by_fixed';
                }
            };

            // if (giaCuoiCung <= 0 && productDetail?.extension_attributes?.final_price && productDetail?.extension_attributes?.final_price < productDetail.price) {
            //     giaCuoiCung = productDetail.extension_attributes.final_price;
            // }

            if (isArray(productDetail?.extension_attributes?.detail_information) && productDetail?.extension_attributes?.detail_information.find(item => item.code == 'final_price')?.value) {
                giaGoc = productDetail?.extension_attributes?.detail_information.find(item => item.code == 'final_price')?.value;
            }
        }

        if (productDetail?.type_id == 'configurable') {
            const item = childProduct;
            giaGoc = item.price;

            if (item.custom_attributes?.special_price) {
                special_price = dayjs(item.custom_attributes?.special_to_date).diff(dayjs(), 'minute') >= 0 && dayjs(item.custom_attributes?.special_from_date).diff(dayjs(), 'minute') <= 0
                    ? item.custom_attributes?.special_price
                    : 0;
            }
            const sortByPriceFlashSale = (a, b) => {
                if (a.price_flash_sales - b.price_flash_sales > 0) return -1;
                if (a.price_flash_sales - b.price_flash_sales < 0) return 1;
                return 1;
            };
            const sortByPriceDealHot = (a, b) => {
                if (a.price_deal_hot - b.price_deal_hot > 0) return -1;
                if (a.price_deal_hot - b.price_deal_hot < 0) return 1;
                return 1;
            };
            if (!isEmpty(item.extension_attributes?.deal_hot_data)) {
                const saleDatas = item.extension_attributes?.deal_hot_data.sort(sortByPriceDealHot);
                const saleData = saleDatas[0];
                giaCuoiCung = saleData.price_deal_hot;
                giaGiam = saleData.deal_hot_discount_value;
                loaiGiam = saleData.deal_hot_discount_type;
            };

            if (!isEmpty(item.extension_attributes?.flash_sales_data)) {
                const saleDatas = item.extension_attributes?.flash_sales_data.sort(sortByPriceFlashSale);
                const saleData = saleDatas[0];
                if (saleData.price_flash_sales <= giaGoc) {
                    giaCuoiCung = saleData.price_flash_sales;
                    giaGiam = saleData.flash_sales_discount_value;
                    loaiGiam = saleData.flash_sales_discount_type;
                };
            };

            if (item.deal_hot_discount_type) {
                giaCuoiCung = item.discount_value;
                giaGiam = item.deal_hot_discount_value;
                loaiGiam = item.deal_hot_discount_type;
            }

            if (item.flashsales_discount_type) {
                giaCuoiCung = item.price_discount;
                giaGiam = item.flashsales_discount_value;
                loaiGiam = item.flashsales_discount_type;
            }
        }

        if ((giaGiam && loaiGiam)) {
            return <>
                <div style={{ width: '100%' }}>
                    <span className="price-before mr-2">đ{numberWithCommas(giaGoc)}</span>
                    {loaiGiam == 'by_percent' && <span className="number-discount">-{numberWithCommas(giaGiam)}%</span>}
                    {loaiGiam == 'by_fixed' && <span className="number-discount">-{numberWithCommas(giaGiam*100/giaGoc)}%</span>}
                </div>
                <strong className="price_buy">đ{numberWithCommas(giaCuoiCung)}</strong>
            </>;
        }

        if (special_price) {
            return <>
                <div style={{ width: '100%' }}>
                    <span className="price-before mr-2">đ{numberWithCommas(giaGoc)}</span>
                </div>
                <strong className="price_buy">đ{numberWithCommas(special_price)}</strong>
            </>;
        }

        return (<strong className="price_buy">đ{numberWithCommas(giaGoc)}</strong>);
    };

    const changeVariant = (parent, childId) => {
        const findOption = !isEmpty(state.productOptions) && state.productOptions.find(o => o.attribute_id === parent);
        if (findOption && findOption.attribute_value !== childId) {
            setState({
                productOptions: state.productOptions.map(o => {
                    if (o.attribute_id === parent) {
                        return { ...o, attribute_value: childId };
                    }
                    return o;
                })
            });
        }
    };

    const sortByAttribute_id = (a, b) => {
        return a.attribute_id - b.attribute_id;
    };

    const fetchChildProduct = async () => {
        setLoading(true);
        const productOptionsSort = state.productOptions.sort(sortByAttribute_id);
        const configurable_product = productDetail?.extension_attributes?.configurable_product_stock.find(option => {
            return isEqual(option.super_product_attributes.sort(sortByAttribute_id), productOptionsSort);
        });
        const detailProduct = childrenProduct.find(x => x.id == configurable_product?.product_id) || {};
        // detailProduct.qty = configurable_product?.qty;
        // childProduct.is_in_stock = configurable_product?.is_in_stock;

        if (detailProduct.sku) {
            const res = await http(`/rest/V1/products/${formatSku(detailProduct.sku)}`, {}, { token: 'default' });
            if (res.extension_attributes?.future_price) {
                let futurePrice = '';

                const flashSalePrice = res?.extension_attributes?.future_price?.flashsale_price;
                const dealHotPrice = res?.extension_attributes?.future_price?.dealhot_price;

                if (flashSalePrice && dealHotPrice) {
                    if (dayjs(flashSalePrice[1]).diff(dayjs(dealHotPrice[1]), 'minute') >= 0) {
                        futurePrice = dealHotPrice;
                    } else {
                        futurePrice = flashSalePrice;
                    }
                }

                if (flashSalePrice && !dealHotPrice) {
                    futurePrice = flashSalePrice;
                }

                if (!flashSalePrice && dealHotPrice) {
                    futurePrice = dealHotPrice;
                }

                setFuturePrice(futurePrice);
            }
            detailProduct.extension_attributes = res?.extension_attributes;
            if (!isEmpty(res?.custom_attributes) && isArray(res?.custom_attributes)) {
                detailProduct.custom_attributes = Object.assign({}, ...res?.custom_attributes.map(item => ({ [item.attribute_code]: item?.value })));
            }
            detailProduct.qty = detailProduct.extension_attributes?.qty;
            detailProduct.is_in_stock = detailProduct.extension_attributes?.is_in_stock;
        } else {
            detailProduct.price = 0;
        }

        setChildProduct(detailProduct);
        setState({ quantity: detailProduct.qty > 0 ? 1 : 0 });
        setLoading(false);
    };

    useEffect(() => {
        if (isEmpty(state.productOptions) || isEmpty(childrenProduct)) return;
        fetchChildProduct();
    }, [state.productOptions, childrenProduct]);

    const variantsProduct = (detail) => {
        if (isEmpty(detail?.extension_attributes?.configurable_product_options)) {
            return null;
        }
        return detail.extension_attributes.configurable_product_options.map((item, k) => {
            let classActive = '';
            const isClass = !isEmpty(state.productOptions) && state.productOptions.find(o => +o.attribute_id === +item.attribute_id);
            return <div key={k} className="form-group mb-4">
                <label
                    className="d-block font-weight-medium mb-2">
                    {item.label.replace('|size_ghe', '')}
                    {/* {item.label != 'Màu sắc|size_ghe' ? item.label : 'Màu sắc'} */}
                </label>
                <ul className="product-select">
                    {!isEmpty(detail.extension_attributes.hpn_product_option) && detail.extension_attributes.hpn_product_option
                        .filter(f => +f.attribute_id === +item.attribute_id)
                        .map((i, k1) => {
                            if (isClass && +isClass.attribute_value === i.value) {
                                classActive = 'active';
                            } else if (!isClass && k1 == 0) {
                                classActive = 'active';
                            } else {
                                classActive = '';
                            }
                            return <li key={k1} className={classActive}
                                onClick={() => changeVariant(+item.attribute_id, +i.value)}
                            >{i.label}</li>;
                        })}
                </ul>
            </div>;
        });
    };

    const fetchCoupon = async () => {
        let couponShop = [];
        let couponFreeShip = [];

        const couponsVendor = await http(`/rest/V1/vendors/coupon/${vendor.id}`, { size: 0 }, { token: 'default' });
        const couponsHappynest = await http(`/rest/V1/happyNest/salesRules/search`, { size: 0 });
        // const couponsFreeShipRes = await http(`/rest/V1/freeShipping/coupon`, { size: 0 }, { token: 'default' });

        // if (!isEmpty(couponsVendor.items)) {
        // couponShop = couponsVendor.items.filter(coupon => {
        //     return coupon.coupon_type == '1';
        // });

        // couponFreeShip = couponsVendor.items.filter(coupon => {
        //     return coupon.coupon_type == '3' || coupon.coupon_type == '2';
        // });
        // };

        // if (!isEmpty(couponsFreeShipRes)) {
        //     couponFreeShip.concat(couponsFreeShipRes.filter(coupon => {
        //         return coupon.coupon_type == '3' || coupon.coupon_type == '2';
        //     })
        //     );
        // }

        couponsHappynest.items.forEach(coupon => {
            coupon.discount_type = coupon.simple_action;
            coupon.amount = coupon.discount_amount;
        });

        const khongDapUngDieuKien = (condition) => {
            return (condition.attribute_name == 'vendor_id' && condition.operator != '!=' && condition.value != vendor.id)
                || (condition.attribute_name == 'vendor_id' && condition.operator == '!=' && condition.value == vendor.id)
                || (condition.attribute_name == 'sku' && condition.value.indexOf(productDetail.sku) == -1)
                || (condition.attribute_name == 'category_ids' && !productDetail.custom_attributes.category_ids.some(cate => condition.value.indexOf(cate) > -1));
        };

        const couponHappynestDisplay = couponsHappynest.items.filter(x => {
            if (!x.action_condition?.conditions) return true;
            if (!isArray(x.action_condition?.conditions)) return true;

            return !x.action_condition.conditions.some(condition => {
                if (isArray(condition.conditions)) {
                    return condition.conditions.some(con => {
                        return khongDapUngDieuKien(con);
                    });
                }
                return khongDapUngDieuKien(condition);
            });
        });


        setState({
            couponsVendor: couponsVendor?.items || [],
            couponsHappynest: couponHappynestDisplay,
            couponDisplay: (couponsVendor?.items || []).concat(couponHappynestDisplay),
        });
        // setState({ couponsFreeShip: couponFreeShip });
    };

    useEffect(() => {
        if (isEmpty(vendor)) return;
        fetchCoupon();
    }, [vendor]);

    // const [useCoupon, setUseCoupon] = useState(null);
    const genCouponList = state.couponsVendor.map((item, index) => {
        return (<CouponProduct key={index} coupon={item} vendor={vendor} />);
    });

    const genHPNCouponList = state.couponsHappynest.map((item, index) => {
        const vendor = {};
        vendor.logo = '/images/icon-shop-app.png';
        vendor.shop_name = 'Happynest';
        item.code = item.coupons[0]?.code || 'NO_COUPON';
        return (<CouponProduct key={index} coupon={item} vendor={vendor} />);
    });

    // const genCouponFreeShip = state.couponsFreeShip.map((item, index) => {
    //     return (<CouponProduct key={index} coupon={item} vendor={vendor} />);
    // });
    const reviewSummary = Math.round(productDetail.extension_attributes?.rating_summary);
    if (typeof window !== 'undefined') {
        const getChild = async (parentSku = productDetail.sku) => {
            try {
                const res = await http(`/rest/V1/products/${formatSku(parentSku)}`, {});
                const options = res.extension_attributes.hpn_product_option;

                const res1 = await http(`/rest/V1/configurable-products/${`${formatSku(parentSku)}`}/children`, {});
                if (isArray(res1)) {
                    res1.forEach(child => {
                        child.options = {};
                        options.forEach(x => {
                            if (child.custom_attributes.some(y => y.value == x.value)) {
                                child.options[x.attribute_label] = x.label;
                            }
                        });
                    });
                    console.log(res1);
                };
            } catch (e) {
                console.log('Xảy ra lỗi');
            }
        };
        window.getChild = getChild;
    }
    return (
        <div className="deatil_info">
            <div style={{ display: 'none'}} id="child-product">{JSON.stringify(childrenProduct)}</div>
            <h2 className="product-name">{productDetail.name}</h2>
            <div className="view-rate">
                <div className="rate-star">
                    <StarList number={reviewSummary} />
                    <span className="number">({productDetail?.extension_attributes?.reviews_count || 0})</span>
                </div>
            </div>
            <div className="price_wrap">
                {genPrice()}
                {
                    futurePrice && <p style={{ width: '100%' }}>Chờ giá <span className='future-price'>{getXXXPrice(Math.round(futurePrice[0]))}đ</span> vào <span className='future-price'>{dayjs(futurePrice[1]).format('HH:mm')} ngày {dayjs(futurePrice[1]).format('DD/MM/YYYY')}</span></p>
                }
            </div>


            <ul className="list-detail">
                {
                    !isEmpty(state.couponDisplay) && ![3, 4].includes(groupId) &&
                    <>
                        <li onClick={() => setState({ showModalCoupon: true })} className="need" style={{ cursor: 'pointer' }}>
                            <span className="icon"><img src="/images/icon-shop-ticket.png" alt="" /></span>
                            <div className="info">
                                <div className="info-text" style={{ lineHeight: '24px' }}>
                                    <p className="font-weight-semibold">Mã giảm giá</p>
                                </div>
                                <div className="info-code font-weight-semibold" style={{ lineHeight: '24px' }}>{state.couponDisplay.length} mã</div>
                            </div>
                        </li>
                        <li onClick={() => setState({ showModalCoupon: true })} style={{ cursor: 'pointer' }}>
                            <div className='coupon-display-box' style={{ height: '29px', overflow: 'hidden' }}>
                                {
                                    state.couponDisplay.slice(0, 5).map((coupon, index) => {
                                        if (coupon.coupon_type == 3) {
                                            return <Coupon key={index} value="FREESHIP" />;
                                        }
                                        return <Coupon key={index} value={
                                            coupon.discount_type === 'by_percent' ? `GIẢM ${numberWithCommas(+coupon.amount)}%` : `GIẢM ${displayWithK(+coupon.amount)}`
                                        } />;
                                    })
                                }
                            </div>
                        </li>
                    </>
                }
                {/* <li onClick={() => setState({ showModalFreeShip: true })} className="need" style={{ cursor: 'pointer' }}>
                    <span className="icon"><img src="/images/icon-shop-delivery.png" alt=""/></span>
                    <div className="info">
                        <div className="info-text">
                            <p className="font-weight-medium">Chọn mã giảm giá vận chuyển</p>
                        </div>
                    </div>
                </li> */}
                {ship &&
                    <li className={(ship === 'all' || (ship !== 'all' && ship.split(',').length <= 2)) ? "" : "need"} onClick={() => setState({ showModalShipping: true })} style={{ cursor: 'pointer' }}>
                        <span className="icon"><Image width={25} height={25} src="/images/icon-location.svg" alt="" /></span>
                        <div className="info">
                            <div className="info-text">
                                <p className="font-weight-semibold">Phạm vi giao hàng</p>
                                {ship === 'all' && <p className="">Giao hàng trên toàn quốc</p>}
                                {ship !== 'all' && ship.split(',').length > 2 && <p className="">Giao hàng tại một số địa phương</p>}
                                {ship !== 'all' && ship.split(',').length <= 2 && <p className="">Giao hàng tại {ship.split(',')[0]} {ship.split(',')[1] ? 'và ' + ship.split(',')[1] : ''}</p>}
                            </div>
                        </div>
                    </li>
                }
            </ul>

            {variantsProduct(productDetail)}
            {![3, 4].includes(groupId) && productDetail?.type_id == 'simple' && (productDetail?.extension_attributes?.is_in_stock && productDetail?.extension_attributes?.qty > 0) && <div className="form-group mb-4 d-flex align-items-center">
                <label className="font-weight-medium">Số lượng</label>
                <div className="select-product-number">
                    <div className="quantity-input">
                        <button type="button" className="btn quantity-left-minus" data-type="minus" data-field=""
                            onClick={() => setState({ quantity: state.quantity <= 1 ? 1 : state.quantity - 1 })}>
                            <Image width={16} height={16} src="/images/icon-minus.svg" alt="" />
                        </button>
                        <input type="number" id="quantity" name="quantity" className="form-control" min=""
                            onChange={(e) => setState({ quantity: e.target.value >= productDetail?.extension_attributes?.qty ? productDetail?.extension_attributes?.qty : e.target.value })}
                            value={productDetail?.extension_attributes?.qty != 0 ? state.quantity : 0} />
                        <button type="button" className="btn quantity-right-plus" data-type="plus" data-field=""
                            onClick={() => setState({ quantity: state.quantity >= productDetail?.extension_attributes?.qty ? state.quantity : state.quantity + 1 })}>
                            <Image width={16} height={16} src="/images/icon-plus.svg" alt="" />
                        </button>
                    </div>
                </div>
                <p
                    className="ml-2"
                    style={{ 'color': '#666666' }}>
                    {productDetail?.extension_attributes?.qty} sản phẩm có sẵn
                </p>
            </div>
            }

            {![3, 4].includes(groupId) && productDetail?.type_id == 'configurable' && (childProduct.is_in_stock && childProduct.qty > 0 && productDetail?.extension_attributes?.is_in_stock) && <div className="form-group mb-4 d-flex align-items-center">
                <label className="font-weight-medium">Số lượng</label>
                <div className="select-product-number">
                    <div className="quantity-input">
                        <button type="button" className="btn quantity-left-minus" data-type="minus" data-field=""
                            onClick={() => setState({ quantity: state.quantity <= 1 ? 1 : state.quantity - 1 })}>
                            <Image width={16} height={16} src="/images/icon-minus.svg" alt="" />
                        </button>

                        <input type="number" id="quantity" name="quantity" className="form-control" min=""
                            onChange={(e) => setState({ quantity: e.target.value >= childProduct.qty ? childProduct.qty : e.target.value })}
                            value={childProduct.qty ? state.quantity : 0} />

                        <button type="button" className="btn quantity-right-plus" data-type="plus" data-field=""
                            onClick={() => setState({ quantity: state.quantity >= childProduct.qty ? childProduct.qty : state.quantity + 1 })}>
                            <Image width={16} height={16} src="/images/icon-plus.svg" alt="" />
                        </button>
                    </div>
                </div>
                <p
                    className="ml-2"
                    style={{ 'color': '#666666' }}>
                    {childProduct.qty} sản phẩm có sẵn
                </p>
            </div>
            }

            {
                ![3, 4].includes(groupId)
                && ((productDetail?.type_id != 'configurable' && productDetail?.extension_attributes?.is_in_stock && productDetail?.extension_attributes?.qty > 0)
                    || (productDetail?.type_id == 'configurable' && productDetail?.extension_attributes?.is_in_stock && childProduct.is_in_stock && childProduct.qty > 0))
                && (<div className="button-control pt-2">
                    <button className="btn btn--blueWhite" onClick={addProductToCart}>Thêm vào giỏ</button>
                    <button className="btn btn--blue" onClick={buyNow}>Mua ngay</button>
                </div>)
            }

            {
                !loading && (
                    (productDetail?.type_id != 'configurable' && (productDetail?.extension_attributes?.is_in_stock == false || productDetail?.extension_attributes?.qty == 0))
                    || (productDetail?.type_id == 'configurable' && (!productDetail?.extension_attributes?.is_in_stock || !childProduct.is_in_stock || (!childProduct.qty || childProduct.qty == 0)))
                )
                && <button className="btn btn--gray w-100" disabled>Sản phẩm tạm hết hàng</button>
            }

            {[3, 4].includes(groupId) && <div className="button-control pt-2">
                {
                    (productDetail?.custom_attributes?.aff_link || productDetail?.custom_attributes?.link)
                        ? <Link
                            href={productDetail?.custom_attributes?.aff_link || productDetail?.custom_attributes?.link || ''}
                            passHref={true}
                        >
                            <a target="_blank" className="w-100">
                                <button className="btn btn--blue w-100">{groupId == 3 ? 'Mua trên sàn' : 'Liên hệ để được tư vấn'}</button>
                            </a>
                        </Link>
                        : <button className="btn btn--blue w-100">{groupId == 3 ? 'Mua trên sàn' : 'Liên hệ để được tư vấn'}</button>
                }

            </div>}

            <Modal show={state.showModalCoupon} onHide={() => setState({ showModalCoupon: false })} role="document">
                <Modal.Header closeButton>
                    <h5 className="modal-title">Mã giảm giá</h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-discount-code">
                        {!isEmpty(state.couponsVendor) && <>
                            <p>Mã giảm giá từ Shop</p>
                            <ul className="mb-3">
                                {genCouponList}
                            </ul>
                        </>}
                        {!isEmpty(state.couponsHappynest) && <>
                            <p>Mã giảm giá từ Happynest</p>
                            <ul className="mb-3">
                                {genHPNCouponList}
                            </ul>
                        </>}
                    </div>
                </Modal.Body>
            </Modal>

            {/* <Modal show={state.showModalFreeShip} onHide={() => setState({ showModalFreeShip: false })} role="document">
                <Modal.Header closeButton>
                    <h5 className="modal-title">Mã giảm giá vận chuyển</h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-discount-code">
                        <div className="input-discount-code">
                            <input className="input-code" type="" name="" placeholder="Nhập mã giảm giá của Shop" />
                            <button className="btn-submit">Áp dụng</button>
                        </div>
                        <ul>
                            {genCouponFreeShip}
                        </ul>
                    </div>
                </Modal.Body>
            </Modal> */}

            {ship !== 'all' && <Modal show={state.showModalShipping} onHide={() => setState({ showModalShipping: false })} role="document">
                <Modal.Header closeButton>
                    <h5 className="modal-title">Phạm vi giao hàng</h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-discount-code">
                        <ul style={{ listStyle: 'inside' }}>
                            {
                                ship.split(',').map((item, index) => {
                                    return <li key={index}>{item.trim()} </li>;
                                })
                            }
                        </ul>
                    </div>
                </Modal.Body>
            </Modal>}
            <Loader loading={loading} />
        </div>
    );
};
